import * as React from 'react'

export type InfoCardProps = {
	title: string
	items: React.ReactNode[]
	footerLogo?: React.ReactNode
	className?: string
	titleColorClass?: string
}

export const FunctionalReachCard: React.FC<InfoCardProps> = ({
	title,
	items,
	footerLogo,
	className,
	titleColorClass = 'text-error-500',
}) => {
	return (
		<div
			className={`flex flex-col justify-between gap-6 rounded-2xl border border-gray-200 bg-white p-8 shadow-sm ${className}`}
		>
			<div className="flex flex-col gap-4">
				<h3 className={`text-[24px] font-medium ${titleColorClass}`}>
					{title}
				</h3>

				<ul className="list-inside list-disc leading-relaxed text-gray-700">
					{items.map((item, index) => item)}
				</ul>
			</div>

			{footerLogo && (
				<div className="flex justify-center pt-6">{footerLogo}</div>
			)}
		</div>
	)
}
